/* hom51-cart.js - dezenter Upsell in der Warenkorb-Schublade (T1). Zeigt EIN passendes Teil unter den Positionen. T1b 19.10.: Playboy51-Teile mit einheitlichem Theme-Asset-Bild; Einzelvariante -> 'Dazu'-Knopf (44 px). */
(function () {
  if (window.__h51cart) return;
  window.__h51cart = true;
  var SPERRE = /limited|release|vorbestell|zertifikat|personal|gutschein|cd\b/i;
  var P51 = ',herren-hoodie-p51-piratenboss-totenkopf,herren-hoodie-p51-ahh-saol-wappen,p51-pb-hoodie-sw-aermel,p51-wappen-hoodie-sw-aermel,herren-t-shirt-p51-piratenboss-totenkopf,herren-t-shirt-p51-ahh-saol-wappen,dad-cap-p51-ahh-saol-wappen,tragetasche-p51-piratenboss-totenkopf,tragetasche-p51-ahh-saol-wappen,tasse-p51-piratenboss-totenkopf,tasse-p51-ahh-saol-wappen,kopfkissen-p51-piratenboss-totenkopf,kopfkissen-p51-ahh-saol-wappen,badelatschen-p51-ahh-saol-wappen,p51-poster-antenne,p51-poster-schatzkarte,';
  function assetBase() {
    var l = document.querySelector('link[href*="hom51-shop.css"]') || document.querySelector('link[href*="/assets/hom51-"]');
    return l ? l.href.split('/assets/')[0] + '/assets/' : '';
  }
  function euro(c) { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  var laeuft = false;
  function einbauen() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.classList.contains('is-empty') || laeuft) return;
    var inner = d.querySelector('.drawer__inner');
    var foot = inner && inner.querySelector('.drawer__footer');
    if (!foot || inner.querySelector('.h51-up')) return;
    laeuft = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items.length) return;
      var pid = cart.items[cart.items.length - 1].product_id;
      var drin = {};
      cart.items.forEach(function (i) { drin[i.product_id] = 1; });
      return fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related').then(function (r) { return r.json(); }).then(function (j) {
        var liste = (j.products || []).filter(function (p) {
          return p.available && !drin[p.id] && !SPERRE.test(p.title + ' ' + (p.tags || []).join(' ') + ' ' + (p.type || ''));
        });
        var p = liste.filter(function (x) { return x.price <= 3500; })[0] || liste[0];
        if (!p || inner.querySelector('.h51-up')) return;
        var einzeln = p.variants.length === 1 && p.variants[0].available;
        var bild = p.featured_image ? esc(p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) : '';
        var base = assetBase();
        if (base && P51.indexOf(',' + p.handle + ',') > -1) bild = esc(base + 'hom51-prod-' + p.handle + '-front.jpg?width=160');
        var el = document.createElement('div');
        el.className = 'h51-up';
        el.innerHTML = (bild ? '<img src="' + bild + '" alt="" width="64" height="80" loading="lazy">' : '<span></span>') +
          '<div><div class="h51-up__l">Passt dazu</div><a class="h51-up__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="h51-up__p">' + euro(p.price) + '</span></div>' +
          (einzeln ? '<button type="button" data-id="' + p.variants[0].id + '">Dazu</button>' : '<a class="h51-btn h51-btn--sm" href="' + esc(p.url) + '">Ansehen</a>');
        foot.parentNode.insertBefore(el, foot);
        var b = el.querySelector('button');
        if (b) b.addEventListener('click', function () {
          b.disabled = true; b.textContent = '...';
          var secs = d.getSectionsToRender().map(function (s) { return s.id; });
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(b.dataset.id), quantity: 1, sections: secs, sections_url: window.location.pathname }) })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) { b.textContent = 'Nicht möglich'; return; }
              d.renderContents(res);
              try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hom51-upsell', cartData: res }); } catch (e) {}
            })
            .catch(function () { b.textContent = 'Fehler'; });
        });
      });
    }).catch(function () {}).then(function () { laeuft = false; });
  }
  var t;
  function plan() { clearTimeout(t); t = setTimeout(einbauen, 250); }
  function start() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    new MutationObserver(plan).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    plan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
